/* eslint-disable */
import React from "react";
import { supabase } from "./supabaseClient";

const C = {
  primary:"#1a6b3c", primaryPale:"#e8f5ee", primaryDark:"#0d3d1f",
  amber:"#d97706",   amberPale:"#fffbeb",   amberMid:"#fde68a",
  rose:"#e11d48",    rosePale:"#fef2f2",
  blue:"#2563eb",    bluePale:"#eff6ff",
  text:"#111827",    muted:"#6b7280",       border:"#d1fae5",
  white:"#ffffff",   shadow:"rgba(0,0,0,0.06)",
};

const MIN_CHARS = 30;

const SECTIONS = [
  { id:"attendance_summary",      icon:"📊", label:"Attendance Summary",          required:true,  autoStats:"attendance",
    placeholder:"Add any additional context — notable absences, patterns, concerns beyond the numbers above..." },
  { id:"academic_update",         icon:"🎓", label:"Academic Update",             required:false, autoStats:null,
    placeholder:"Teaching quality observations, assessments completed, course plan progress, any subject concerns..." },
  { id:"admissions_enrolment",    icon:"📋", label:"Admissions & Enrolment",      required:false, autoStats:"admissions",
    placeholder:"Add context — pending enquiries, families met, expected joiners, any withdrawals being processed..." },
  { id:"discipline_welfare",      icon:"🚨", label:"Discipline & Student Welfare", required:true,  autoStats:"discipline",
    placeholder:"Describe incidents in detail, actions taken, any ongoing welfare concerns or safeguarding matters..." },
  { id:"staff_matters",           icon:"🧑‍🏫", label:"Staff Matters",               required:true,  autoStats:"staffconduct",
    placeholder:"Add context on absences, attitude concerns, commendations, or any HR matters not captured above..." },
  { id:"premises_resources",      icon:"🏫", label:"Premises & Resources",        required:false, autoStats:null,
    placeholder:"IT/equipment issues, maintenance needed, classroom cleanliness or safety concerns, supply shortages..." },
  { id:"events_upcoming",         icon:"📅", label:"Events & Upcoming",           required:false, autoStats:"events",
    placeholder:"Add any context on events above, or mention informal activities not logged in the system..." },
  { id:"parent_community",        icon:"👪", label:"Parent & Community",          required:false, autoStats:null,
    placeholder:"Parent meetings or calls held, complaints or feedback received, community engagement..." },
  { id:"requests_for_management", icon:"🙋", label:"Requests for Management",     required:true,  autoStats:null,
    placeholder:"Be specific — what decision, approval, or support do you need from ownership this week?" },
  { id:"forward_look",            icon:"🔭", label:"Forward Look",                required:true,  autoStats:null,
    placeholder:"Your planned focus and key priorities for the coming week..." },
];

const STATUS_META = {
  draft:     { label:"Draft",           col:"#6b7280", bg:"#f3f4f6",    border:"#e5e7eb" },
  submitted: { label:"Awaiting Review", col:C.amber,   bg:C.amberPale,  border:C.amberMid },
  reviewed:  { label:"Reviewed",        col:C.primary, bg:C.primaryPale,border:C.border },
};

const getWeekStart = () => {
  const d = new Date();
  const day = d.getDay();
  const mon = new Date(d);
  mon.setDate(d.getDate() - day + (day === 0 ? -6 : 1));
  mon.setHours(0,0,0,0);
  return mon.toISOString().split("T")[0];
};

const addDays = (dateStr, n) => {
  const d = new Date(dateStr + "T00:00:00");
  d.setDate(d.getDate() + n);
  return d.toISOString().split("T")[0];
};

const weekLabel  = (ds) => `W/C ${new Date(ds+"T00:00:00").toLocaleDateString("en-GB",{day:"numeric",month:"short",year:"numeric"})}`;
const fmtDate    = (ds) => ds ? new Date(ds+"T00:00:00").toLocaleDateString("en-GB",{weekday:"short",day:"numeric",month:"short"}) : "—";
const fmtTime    = (ts) => ts ? new Date(ts).toLocaleDateString("en-GB",{day:"numeric",month:"short",year:"numeric",hour:"2-digit",minute:"2-digit"}) : "—";
const isPresent  = (s)  => ["P","Present","L","Late"].includes(s);

function Toast({ toast }) {
  if (!toast) return null;
  return (
    <div style={{position:"fixed",top:20,right:20,zIndex:9999,background:toast.ok?"#f0fdf4":"#fef2f2",color:toast.ok?"#16a34a":"#dc2626",border:`1px solid ${toast.ok?"#bbf7d0":"#fecaca"}`,borderRadius:10,padding:"10px 18px",fontWeight:700,fontSize:13,boxShadow:"0 4px 18px rgba(0,0,0,.15)",maxWidth:320}}>
      {toast.msg}
    </div>
  );
}

const ta  = {width:"100%",padding:"10px 12px",borderRadius:8,border:`1px solid ${C.border}`,fontSize:13,lineHeight:1.7,resize:"vertical",minHeight:80,boxSizing:"border-box",fontFamily:"inherit",color:C.text};
const btn = (bg, col="white") => ({background:bg,color:col,border:"none",borderRadius:8,padding:"9px 18px",fontWeight:700,fontSize:13,cursor:"pointer"});
const ghostBtn = {background:"none",border:`1px solid ${C.border}`,borderRadius:8,padding:"9px 18px",fontWeight:700,fontSize:13,cursor:"pointer",color:C.muted};

// ── Auto-stats block rendered above each relevant section ──────────────────
function StatsBlock({ type, stats }) {
  if (!stats) return (
    <div style={{background:"#f9fafb",borderRadius:8,padding:"10px 12px",fontSize:12,color:C.muted,marginBottom:8,border:`1px dashed #e5e7eb`}}>
      ⏳ Loading this week's data…
    </div>
  );

  if (type === "attendance") {
    if (!stats.attendance.length) return (
      <div style={{background:"#f9fafb",borderRadius:8,padding:"10px 12px",fontSize:12,color:C.muted,marginBottom:8,border:`1px dashed #e5e7eb`}}>
        📊 No attendance records found for this week yet.
      </div>
    );
    return (
      <div style={{background:C.bluePale,borderRadius:8,padding:"10px 14px",marginBottom:8,border:`1px solid #bfdbfe`}}>
        <div style={{fontSize:11,fontWeight:800,color:C.blue,marginBottom:8,textTransform:"uppercase",letterSpacing:.5}}>📊 This Week's Attendance by Class</div>
        <div style={{display:"flex",flexWrap:"wrap",gap:8}}>
          {stats.attendance.map(a=>(
            <div key={a.class} style={{background:"white",borderRadius:7,padding:"6px 12px",border:`1px solid #bfdbfe`,minWidth:110}}>
              <div style={{fontWeight:700,fontSize:12,color:C.text}}>{a.class}</div>
              <div style={{fontWeight:900,fontSize:18,color:a.pct>=85?C.primary:a.pct>=75?C.amber:C.rose,lineHeight:1.2}}>{a.pct}%</div>
              <div style={{fontSize:10,color:C.muted}}>{a.present}/{a.total} days marked</div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (type === "admissions") {
    return (
      <div style={{background:C.primaryPale,borderRadius:8,padding:"10px 14px",marginBottom:8,border:`1px solid ${C.border}`}}>
        <div style={{fontSize:11,fontWeight:800,color:C.primary,marginBottom:8,textTransform:"uppercase",letterSpacing:.5}}>📋 Enrolment Snapshot</div>
        <div style={{display:"flex",gap:16,flexWrap:"wrap"}}>
          <div style={{background:"white",borderRadius:7,padding:"6px 14px",border:`1px solid ${C.border}`}}>
            <div style={{fontWeight:900,fontSize:20,color:C.primary,lineHeight:1.2}}>{stats.admissions.total}</div>
            <div style={{fontSize:10,color:C.muted}}>Total Roll</div>
          </div>
          <div style={{background:"white",borderRadius:7,padding:"6px 14px",border:`1px solid ${C.border}`}}>
            <div style={{fontWeight:900,fontSize:20,color:C.blue,lineHeight:1.2}}>{stats.admissions.newThisWeek.length}</div>
            <div style={{fontSize:10,color:C.muted}}>New This Week</div>
          </div>
        </div>
        {stats.admissions.newThisWeek.length > 0 && (
          <div style={{marginTop:8,display:"flex",flexWrap:"wrap",gap:6}}>
            {stats.admissions.newThisWeek.map(s=>(
              <span key={s.id} style={{background:"white",border:`1px solid ${C.border}`,borderRadius:6,padding:"2px 8px",fontSize:11,color:C.text}}>
                {s.full_name||s.name} ({s.class})
              </span>
            ))}
          </div>
        )}
      </div>
    );
  }

  if (type === "discipline") {
    const { total, byType } = stats.discipline;
    if (!total) return (
      <div style={{background:"#f0fdf4",borderRadius:8,padding:"10px 12px",fontSize:12,color:C.primary,marginBottom:8,border:`1px solid ${C.border}`}}>
        ✅ No student discipline incidents recorded this week.
      </div>
    );
    return (
      <div style={{background:C.rosePale,borderRadius:8,padding:"10px 14px",marginBottom:8,border:`1px solid #fecaca`}}>
        <div style={{fontSize:11,fontWeight:800,color:C.rose,marginBottom:8,textTransform:"uppercase",letterSpacing:.5}}>🚨 Student Conduct This Week — {total} incident{total!==1?"s":""}</div>
        <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
          {Object.entries(byType).map(([type,count])=>(
            <span key={type} style={{background:"white",border:"1px solid #fecaca",borderRadius:6,padding:"3px 10px",fontSize:11,color:C.rose,fontWeight:700}}>
              {type}: {count}
            </span>
          ))}
        </div>
      </div>
    );
  }

  if (type === "staffconduct") {
    const records = stats.staffConduct;
    if (!records.length) return (
      <div style={{background:"#f0fdf4",borderRadius:8,padding:"10px 12px",fontSize:12,color:C.primary,marginBottom:8,border:`1px solid ${C.border}`}}>
        ✅ No staff conduct entries this week.
      </div>
    );
    return (
      <div style={{background:C.amberPale,borderRadius:8,padding:"10px 14px",marginBottom:8,border:`1px solid ${C.amberMid}`}}>
        <div style={{fontSize:11,fontWeight:800,color:C.amber,marginBottom:8,textTransform:"uppercase",letterSpacing:.5}}>🧑‍🏫 Staff Conduct This Week — {records.length} entr{records.length!==1?"ies":"y"}</div>
        <div style={{display:"flex",flexDirection:"column",gap:5}}>
          {records.slice(0,5).map(r=>(
            <div key={r.id} style={{background:"white",borderRadius:6,padding:"5px 10px",fontSize:12,display:"flex",justifyContent:"space-between",gap:8}}>
              <span style={{color:C.text}}><strong>{r.staff_name}</strong> — {r.title||r.type}</span>
              <span style={{color:C.muted,whiteSpace:"nowrap"}}>{r.type}</span>
            </div>
          ))}
          {records.length>5 && <div style={{fontSize:11,color:C.muted}}>+ {records.length-5} more</div>}
        </div>
      </div>
    );
  }

  if (type === "events") {
    const { thisWeek, nextWeek } = stats.events;
    if (!thisWeek.length && !nextWeek.length) return (
      <div style={{background:"#f9fafb",borderRadius:8,padding:"10px 12px",fontSize:12,color:C.muted,marginBottom:8,border:`1px dashed #e5e7eb`}}>
        📅 No events found in the system for this or next week.
      </div>
    );
    return (
      <div style={{background:"#f5f3ff",borderRadius:8,padding:"10px 14px",marginBottom:8,border:`1px solid #ddd6fe`}}>
        <div style={{fontSize:11,fontWeight:800,color:"#6d28d9",marginBottom:8,textTransform:"uppercase",letterSpacing:.5}}>📅 Events from System</div>
        {thisWeek.length>0 && (
          <div style={{marginBottom:8}}>
            <div style={{fontSize:10,fontWeight:700,color:"#6d28d9",marginBottom:4}}>THIS WEEK</div>
            {thisWeek.map(e=><div key={e.id} style={{fontSize:12,color:C.text,padding:"3px 0"}}>{fmtDate(e.date)} — {e.title}</div>)}
          </div>
        )}
        {nextWeek.length>0 && (
          <div>
            <div style={{fontSize:10,fontWeight:700,color:"#6d28d9",marginBottom:4}}>NEXT WEEK</div>
            {nextWeek.map(e=><div key={e.id} style={{fontSize:12,color:C.text,padding:"3px 0"}}>{fmtDate(e.date)} — {e.title}</div>)}
          </div>
        )}
      </div>
    );
  }

  return null;
}

// ── Read-only digest view ──────────────────────────────────────────────────
function DigestReadOnly({ digest, showManagementComment=false }) {
  return (
    <div style={{padding:"4px 18px 18px",display:"flex",flexDirection:"column",gap:10}}>
      {SECTIONS.map(sec => (
        <div key={sec.id} style={{background:"#f9fafb",borderRadius:9,padding:"12px 14px"}}>
          <div style={{fontWeight:700,fontSize:12,color:C.muted,marginBottom:4,textTransform:"uppercase",letterSpacing:.4}}>
            {sec.icon} {sec.label} {sec.required && <span style={{color:C.rose,fontSize:10}}>required</span>}
          </div>
          <div style={{fontSize:13,color:C.text,lineHeight:1.75,whiteSpace:"pre-wrap"}}>
            {digest[sec.id] || <span style={{color:"#d1d5db",fontStyle:"italic"}}>Not filled</span>}
          </div>
        </div>
      ))}
      {showManagementComment && digest.management_comment && (
        <div style={{background:C.primaryPale,borderRadius:9,padding:"12px 14px",border:`1px solid ${C.border}`}}>
          <div style={{fontWeight:700,fontSize:12,color:C.primary,marginBottom:4}}>💬 MANAGEMENT COMMENT</div>
          <div style={{fontSize:13,color:C.text,lineHeight:1.75,whiteSpace:"pre-wrap"}}>{digest.management_comment}</div>
          <div style={{fontSize:11,color:C.muted,marginTop:6}}>— {digest.commented_by} · {fmtTime(digest.commented_at)}</div>
        </div>
      )}
    </div>
  );
}

// ── Principal View ─────────────────────────────────────────────────────────
function PrincipalView({ userName }) {
  const thisWeek    = getWeekStart();
  const thisWeekEnd = addDays(thisWeek, 6);
  const nextWeekEnd = addDays(thisWeek, 13);

  const emptyForm = () => ({
    id: null, week_start: thisWeek, week_label: weekLabel(thisWeek),
    ...Object.fromEntries(SECTIONS.map(s => [s.id, ""])),
  });

  const [digests,          setDigests]          = React.useState([]);
  const [form,             setForm]             = React.useState(emptyForm());
  const [view,             setView]             = React.useState("overview");
  const [loading,          setLoading]          = React.useState(true);
  const [saving,           setSaving]           = React.useState(false);
  const [toast,            setToast]            = React.useState(null);
  const [expandedId,       setExpandedId]       = React.useState(null);
  const [stats,            setStats]            = React.useState(null);
  const [confirmingDelete, setConfirmingDelete] = React.useState(null); // digest id

  const showToast = (msg, ok=true) => { setToast({msg,ok}); setTimeout(()=>setToast(null),4000); };

  // Fetch this week's auto-stats
  React.useEffect(() => {
    (async () => {
      const [attRes, stuNewRes, stuTotalRes, condRes, staffCondRes, eventsRes] = await Promise.all([
        supabase.from("attendance").select("student_id,status,date,class").gte("date",thisWeek).lte("date",thisWeekEnd),
        supabase.from("students").select("id,full_name,name,class,created_at").gte("created_at",thisWeek+"T00:00:00"),
        supabase.from("students").select("id"),
        supabase.from("student_conduct").select("*").gte("date",thisWeek),
        supabase.from("staff_conduct").select("*").gte("date",thisWeek),
        supabase.from("school_events").select("*").gte("date",thisWeek).lte("date",nextWeekEnd).order("date"),
      ]);

      // Attendance by class
      const byClass = {};
      (attRes.data||[]).forEach(a => {
        const cls = a.class || "Unknown";
        if (!byClass[cls]) byClass[cls] = {total:0, present:0};
        byClass[cls].total++;
        if (isPresent(a.status)) byClass[cls].present++;
      });
      const attendanceStats = Object.entries(byClass)
        .map(([cls,v])=>({class:cls, total:v.total, present:v.present, pct:Math.round(v.present/v.total*100)}))
        .sort((a,b)=>a.class.localeCompare(b.class));

      // Discipline by type
      const byType = {};
      (condRes.data||[]).forEach(c => { byType[c.type] = (byType[c.type]||0)+1; });

      setStats({
        attendance: attendanceStats,
        admissions: { total: (stuTotalRes.data||[]).length, newThisWeek: stuNewRes.data||[] },
        discipline: { total: (condRes.data||[]).length, byType },
        staffConduct: staffCondRes.data||[],
        events: {
          thisWeek: (eventsRes.data||[]).filter(e=>e.date>=thisWeek && e.date<=thisWeekEnd),
          nextWeek: (eventsRes.data||[]).filter(e=>e.date>thisWeekEnd),
        },
      });
    })();
  }, [thisWeek, thisWeekEnd, nextWeekEnd]);

  const load = React.useCallback(async () => {
    setLoading(true);
    const { data } = await supabase.from("weekly_digests").select("*").order("week_start",{ascending:false});
    setDigests(data||[]);
    setLoading(false);
  }, []);
  React.useEffect(()=>{ load(); },[load]);

  const thisDigest = digests.find(d=>d.week_start===thisWeek);

  const openForm = (digest=null) => {
    setForm(digest
      ? { id:digest.id, week_start:digest.week_start, week_label:weekLabel(digest.week_start), ...Object.fromEntries(SECTIONS.map(s=>[s.id,digest[s.id]||""])) }
      : emptyForm()
    );
    setView("writing");
    window.scrollTo(0,0);
  };

  const recallDigest = async (digest) => {
    const { data, error } = await supabase.from("weekly_digests").update({status:"draft"}).eq("id",digest.id).select().single();
    if (error) { showToast("Error: "+error.message,false); return; }
    setDigests(p=>p.map(d=>d.id===data.id?data:d));
    openForm(data);
  };

  const deleteDigest = async (id) => {
    const { error } = await supabase.from("weekly_digests").delete().eq("id",id);
    if (error) { showToast("Error: "+error.message,false); return; }
    setDigests(p=>p.filter(d=>d.id!==id));
    setConfirmingDelete(null);
    showToast("Digest deleted.");
  };

  const saveDraft = async () => {
    setSaving(true);
    const payload = { week_start:form.week_start, week_label:weekLabel(form.week_start), status:"draft", submitted_by:userName, ...Object.fromEntries(SECTIONS.map(s=>[s.id,form[s.id]||null])) };
    if (form.id) {
      const { data, error } = await supabase.from("weekly_digests").update(payload).eq("id",form.id).select().single();
      if (error) { showToast("Error: "+error.message,false); setSaving(false); return; }
      setDigests(p=>p.map(d=>d.id===data.id?data:d));
    } else {
      const { data, error } = await supabase.from("weekly_digests").insert(payload).select().single();
      if (error) { showToast("Error: "+error.message,false); setSaving(false); return; }
      setForm(f=>({...f,id:data.id}));
      setDigests(p=>[data,...p]);
    }
    showToast("Draft saved.");
    setSaving(false);
  };

  const submitDigest = async () => {
    // Validate required sections
    const missing = SECTIONS.filter(s => s.required && (form[s.id]||"").trim().length < MIN_CHARS);
    if (missing.length) {
      showToast(`Please add at least ${MIN_CHARS} characters to: ${missing.map(s=>s.label).join(", ")}`, false);
      return;
    }
    setSaving(true);
    const payload = { week_start:form.week_start, week_label:weekLabel(form.week_start), status:"submitted", submitted_by:userName, submitted_at:new Date().toISOString(), ...Object.fromEntries(SECTIONS.map(s=>[s.id,form[s.id]||null])) };
    if (form.id) {
      const { data, error } = await supabase.from("weekly_digests").update(payload).eq("id",form.id).select().single();
      if (error) { showToast("Error: "+error.message,false); setSaving(false); return; }
      setDigests(p=>p.map(d=>d.id===data.id?data:d));
    } else {
      const { data, error } = await supabase.from("weekly_digests").insert(payload).select().single();
      if (error) { showToast("Error: "+error.message,false); setSaving(false); return; }
      setDigests(p=>[data,...p]);
    }
    showToast("Digest submitted to management ✅");
    setView("overview");
    setSaving(false);
  };

  if (loading) return <div style={{color:C.muted,fontSize:13,padding:16}}>Loading…</div>;

  // ── Writing view ──
  if (view === "writing") {
    const requiredSecs = SECTIONS.filter(s=>s.required);
    const filledRequired = requiredSecs.filter(s=>(form[s.id]||"").trim().length>=MIN_CHARS).length;
    const allRequiredDone = filledRequired === requiredSecs.length;

    return (
      <div style={{display:"flex",flexDirection:"column",gap:14}}>
        <Toast toast={toast}/>
        <div style={{background:`linear-gradient(135deg,${C.primaryDark},${C.primary})`,borderRadius:14,padding:"18px 22px",color:"white",position:"sticky",top:0,zIndex:10}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:10}}>
            <div>
              <div style={{fontWeight:900,fontSize:16}}>📝 Weekly Digest — {weekLabel(form.week_start)}</div>
              <div style={{fontSize:12,opacity:.8,marginTop:2}}>
                {filledRequired}/{requiredSecs.length} required sections complete
                {allRequiredDone ? " ✅" : ` — ${MIN_CHARS}+ chars needed`}
              </div>
            </div>
            <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
              <button onClick={()=>setView("overview")} style={{background:"rgba(255,255,255,.15)",color:"white",border:"1px solid rgba(255,255,255,.3)",borderRadius:8,padding:"8px 14px",fontWeight:700,fontSize:12,cursor:"pointer"}}>← Back</button>
              <button onClick={saveDraft} disabled={saving} style={{background:"rgba(255,255,255,.2)",color:"white",border:"1px solid rgba(255,255,255,.4)",borderRadius:8,padding:"8px 14px",fontWeight:700,fontSize:12,cursor:"pointer"}}>
                {saving?"Saving…":"💾 Save Draft"}
              </button>
              <button onClick={submitDigest} disabled={saving} style={{background:allRequiredDone?"white":"rgba(255,255,255,.35)",color:allRequiredDone?C.primary:"rgba(255,255,255,.7)",border:"none",borderRadius:8,padding:"8px 18px",fontWeight:800,fontSize:12,cursor:allRequiredDone?"pointer":"not-allowed"}}>
                {saving?"Submitting…":"📤 Submit to Management"}
              </button>
            </div>
          </div>
        </div>

        {SECTIONS.map(sec => {
          const val = form[sec.id]||"";
          const charOk = !sec.required || val.trim().length >= MIN_CHARS;
          return (
            <div key={sec.id} style={{background:C.white,borderRadius:12,border:`2px solid ${sec.required&&!charOk?"#fca5a5":charOk&&sec.required?C.border:C.border}`,padding:"14px 18px"}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:10}}>
                <div style={{fontWeight:800,fontSize:13,color:C.text}}>{sec.icon} {sec.label}</div>
                <div style={{display:"flex",gap:6,alignItems:"center"}}>
                  {sec.required
                    ? charOk
                      ? <span style={{fontSize:11,color:C.primary,fontWeight:700}}>✅ Required</span>
                      : <span style={{fontSize:11,color:C.rose,fontWeight:700}}>Required · {Math.max(0,MIN_CHARS-val.trim().length)} chars needed</span>
                    : <span style={{fontSize:11,color:C.muted}}>Optional</span>}
                </div>
              </div>
              {sec.autoStats && <StatsBlock type={sec.autoStats} stats={stats}/>}
              <textarea
                value={val}
                onChange={e=>setForm(f=>({...f,[sec.id]:e.target.value}))}
                placeholder={sec.placeholder}
                style={{...ta, borderColor: sec.required&&!charOk?"#fca5a5":C.border}}
              />
              <div style={{textAlign:"right",fontSize:11,color:val.trim().length>=MIN_CHARS||!sec.required?C.muted:C.rose,marginTop:4}}>
                {val.trim().length} characters
              </div>
            </div>
          );
        })}

        <div style={{display:"flex",justifyContent:"flex-end",gap:8,paddingBottom:20}}>
          <button onClick={saveDraft} disabled={saving} style={btn("#6b7280")}>{saving?"Saving…":"💾 Save Draft"}</button>
          <button onClick={submitDigest} disabled={saving||!allRequiredDone} style={btn(allRequiredDone?C.primary:"#9ca3af")}>
            {saving?"Submitting…":"📤 Submit to Management"}
          </button>
        </div>
      </div>
    );
  }

  // ── Overview ──
  return (
    <div style={{display:"flex",flexDirection:"column",gap:14}}>
      <Toast toast={toast}/>
      <div style={{background:`linear-gradient(135deg,${C.primaryDark},${C.primary})`,borderRadius:14,padding:"20px 24px",color:"white"}}>
        <div style={{fontWeight:900,fontSize:16,marginBottom:4}}>📋 This Week's Digest</div>
        <div style={{fontSize:12,opacity:.8,marginBottom:14}}>{weekLabel(thisWeek)}</div>
        {!thisDigest ? (
          <>
            <div style={{fontSize:13,opacity:.85,marginBottom:12}}>You haven't started this week's digest yet.</div>
            <button onClick={()=>openForm(null)} style={{background:"rgba(255,255,255,.2)",color:"white",border:"1px solid rgba(255,255,255,.4)",borderRadius:9,padding:"9px 20px",fontWeight:800,fontSize:13,cursor:"pointer"}}>
              ✏️ Start This Week's Digest
            </button>
          </>
        ) : thisDigest.status==="draft" ? (
          <>
            <span style={{display:"inline-block",background:"rgba(255,255,255,.15)",borderRadius:6,padding:"2px 10px",fontSize:11,fontWeight:700,marginBottom:10}}>Draft saved</span>
            {confirmingDelete===thisDigest.id ? (
              <div style={{background:"rgba(220,38,38,.15)",border:"1px solid rgba(220,38,38,.4)",borderRadius:10,padding:"12px 16px",marginTop:4}}>
                <div style={{fontSize:13,marginBottom:10}}>Delete this draft permanently?</div>
                <div style={{display:"flex",gap:8}}>
                  <button onClick={()=>deleteDigest(thisDigest.id)} style={{background:"#dc2626",color:"white",border:"none",borderRadius:7,padding:"7px 16px",fontWeight:700,fontSize:12,cursor:"pointer"}}>🗑️ Yes, Delete</button>
                  <button onClick={()=>setConfirmingDelete(null)} style={{background:"rgba(255,255,255,.2)",color:"white",border:"1px solid rgba(255,255,255,.4)",borderRadius:7,padding:"7px 14px",fontWeight:700,fontSize:12,cursor:"pointer"}}>Cancel</button>
                </div>
              </div>
            ) : (
              <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                <button onClick={()=>openForm(thisDigest)} style={{background:"rgba(255,255,255,.2)",color:"white",border:"1px solid rgba(255,255,255,.4)",borderRadius:9,padding:"9px 20px",fontWeight:800,fontSize:13,cursor:"pointer"}}>
                  ✏️ Continue & Submit
                </button>
                <button onClick={()=>setConfirmingDelete(thisDigest.id)} style={{background:"rgba(220,38,38,.25)",color:"white",border:"1px solid rgba(220,38,38,.4)",borderRadius:9,padding:"9px 16px",fontWeight:700,fontSize:13,cursor:"pointer"}}>
                  🗑️ Delete Draft
                </button>
              </div>
            )}
          </>
        ) : (
          <>
            <span style={{display:"inline-block",background:"rgba(255,255,255,.2)",borderRadius:6,padding:"3px 12px",fontSize:12,fontWeight:700,marginBottom:10}}>
              {thisDigest.status==="reviewed" ? "✅ Reviewed by Management" : "⏳ Awaiting Management Review"}
            </span>
            {thisDigest.status==="submitted" && (
              <div style={{marginBottom:10}}>
                {confirmingDelete===thisDigest.id ? (
                  <div style={{background:"rgba(220,38,38,.15)",border:"1px solid rgba(220,38,38,.4)",borderRadius:10,padding:"12px 16px"}}>
                    <div style={{fontSize:13,marginBottom:10}}>Delete this submitted digest? Management won't be able to see it.</div>
                    <div style={{display:"flex",gap:8}}>
                      <button onClick={()=>deleteDigest(thisDigest.id)} style={{background:"#dc2626",color:"white",border:"none",borderRadius:7,padding:"7px 16px",fontWeight:700,fontSize:12,cursor:"pointer"}}>🗑️ Yes, Delete</button>
                      <button onClick={()=>setConfirmingDelete(null)} style={{background:"rgba(255,255,255,.2)",color:"white",border:"1px solid rgba(255,255,255,.4)",borderRadius:7,padding:"7px 14px",fontWeight:700,fontSize:12,cursor:"pointer"}}>Cancel</button>
                    </div>
                  </div>
                ) : (
                  <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                    <button onClick={()=>recallDigest(thisDigest)} style={{background:"rgba(255,255,255,.2)",color:"white",border:"1px solid rgba(255,255,255,.4)",borderRadius:9,padding:"8px 16px",fontWeight:700,fontSize:12,cursor:"pointer"}}>
                      ↩️ Recall & Edit
                    </button>
                    <button onClick={()=>setConfirmingDelete(thisDigest.id)} style={{background:"rgba(220,38,38,.25)",color:"white",border:"1px solid rgba(220,38,38,.4)",borderRadius:9,padding:"8px 14px",fontWeight:700,fontSize:12,cursor:"pointer"}}>
                      🗑️ Delete
                    </button>
                  </div>
                )}
              </div>
            )}
            {thisDigest.management_comment && (
              <div style={{background:"rgba(255,255,255,.12)",borderRadius:10,padding:"12px 16px",marginTop:8}}>
                <div style={{fontSize:11,fontWeight:700,opacity:.7,marginBottom:4}}>💬 MANAGEMENT COMMENT</div>
                <div style={{fontSize:13,lineHeight:1.7}}>{thisDigest.management_comment}</div>
                <div style={{fontSize:10,opacity:.6,marginTop:6}}>— {thisDigest.commented_by} · {fmtTime(thisDigest.commented_at)}</div>
              </div>
            )}
            {thisDigest.status==="reviewed" && (
              <div style={{fontSize:11,opacity:.6,marginTop:8}}>🔒 Locked — management has reviewed this digest.</div>
            )}
          </>
        )}
      </div>

      {digests.filter(d=>d.week_start!==thisWeek).length>0 && (
        <>
          <div style={{fontWeight:800,fontSize:14,color:C.text}}>Previous Digests</div>
          {digests.filter(d=>d.week_start!==thisWeek).map(d=>{
            const sm = STATUS_META[d.status]||STATUS_META.submitted;
            const isOpen = expandedId===d.id;
            const canEdit = d.status==="draft"||d.status==="submitted";
            const canDelete = d.status==="draft"||d.status==="submitted";
            return (
              <div key={d.id} style={{background:C.white,borderRadius:12,border:`1px solid ${C.border}`,overflow:"hidden"}}>
                <div onClick={()=>setExpandedId(isOpen?null:d.id)} style={{padding:"12px 18px",display:"flex",justifyContent:"space-between",alignItems:"center",cursor:"pointer",gap:10,flexWrap:"wrap"}}>
                  <div>
                    <div style={{fontWeight:700,fontSize:13,color:C.text}}>{d.week_label||weekLabel(d.week_start)}</div>
                    <div style={{fontSize:11,color:C.muted}}>{d.submitted_at ? `Submitted ${fmtTime(d.submitted_at)}` : "Draft"}</div>
                  </div>
                  <div style={{display:"flex",gap:8,alignItems:"center"}}>
                    <span style={{background:sm.bg,color:sm.col,border:`1px solid ${sm.border}`,borderRadius:6,padding:"2px 9px",fontSize:11,fontWeight:700}}>{sm.label}</span>
                    {canEdit && <button onClick={e=>{e.stopPropagation(); d.status==="submitted"?recallDigest(d):openForm(d);}} style={{background:"none",border:`1px solid ${C.border}`,borderRadius:6,padding:"3px 10px",fontSize:11,fontWeight:700,cursor:"pointer",color:C.blue}}>✏️ {d.status==="submitted"?"Recall & Edit":"Edit"}</button>}
                    {canDelete && <button onClick={e=>{e.stopPropagation(); setConfirmingDelete(d.id); setExpandedId(null);}} style={{background:"none",border:"1px solid #fecaca",borderRadius:6,padding:"3px 10px",fontSize:11,fontWeight:700,cursor:"pointer",color:C.rose}}>🗑️</button>}
                    <span style={{color:C.muted,fontSize:12}}>{isOpen?"▲":"▼"}</span>
                  </div>
                </div>
                {confirmingDelete===d.id && (
                  <div style={{margin:"0 18px 14px",background:C.rosePale,borderRadius:9,padding:"12px 14px",border:"1px solid #fecaca"}}>
                    <div style={{fontSize:13,color:C.text,marginBottom:10,fontWeight:600}}>Delete "{d.week_label||weekLabel(d.week_start)}"? This cannot be undone.</div>
                    <div style={{display:"flex",gap:8}}>
                      <button onClick={()=>deleteDigest(d.id)} style={{background:C.rose,color:"white",border:"none",borderRadius:7,padding:"7px 16px",fontWeight:700,fontSize:12,cursor:"pointer"}}>🗑️ Yes, Delete</button>
                      <button onClick={()=>setConfirmingDelete(null)} style={{background:"none",border:`1px solid ${C.border}`,borderRadius:7,padding:"7px 14px",fontWeight:700,fontSize:12,cursor:"pointer",color:C.muted}}>Cancel</button>
                    </div>
                  </div>
                )}
                {isOpen && <DigestReadOnly digest={d} showManagementComment/>}
              </div>
            );
          })}
        </>
      )}
    </div>
  );
}

// ── Admin / Owner View ─────────────────────────────────────────────────────
function AdminView({ userName, readOnly=false }) {
  const [digests,    setDigests]    = React.useState([]);
  const [selectedId, setSelectedId] = React.useState(null);
  const [comment,    setComment]    = React.useState("");
  const [saving,     setSaving]     = React.useState(false);
  const [loading,    setLoading]    = React.useState(true);
  const [toast,      setToast]      = React.useState(null);

  const showToast = (msg,ok=true) => { setToast({msg,ok}); setTimeout(()=>setToast(null),3500); };

  React.useEffect(()=>{
    supabase.from("weekly_digests").select("*").in("status",["submitted","reviewed"]).order("week_start",{ascending:false})
      .then(({data})=>{ setDigests(data||[]); setLoading(false); });
  },[]);

  const selected = digests.find(d=>d.id===selectedId)||null;

  const submitComment = async () => {
    if (!selected||!comment.trim()) return;
    setSaving(true);
    const { data, error } = await supabase.from("weekly_digests").update({
      management_comment:comment.trim(), commented_by:userName, commented_at:new Date().toISOString(), status:"reviewed",
    }).eq("id",selected.id).select().single();
    if (error) { showToast("Error: "+error.message,false); setSaving(false); return; }
    setDigests(p=>p.map(d=>d.id===data.id?data:d));
    setComment("");
    showToast("Comment saved and digest marked as reviewed ✅");
    setSaving(false);
  };

  if (loading) return <div style={{color:C.muted,fontSize:13,padding:16}}>Loading…</div>;

  const pending  = digests.filter(d=>d.status==="submitted").length;
  const reviewed = digests.filter(d=>d.status==="reviewed").length;

  return (
    <div style={{display:"flex",flexDirection:"column",gap:14}}>
      <Toast toast={toast}/>
      <div style={{background:C.white,borderRadius:14,padding:"18px 22px",border:`1px solid ${C.border}`,boxShadow:`0 2px 10px ${C.shadow}`}}>
        <div style={{fontWeight:900,fontSize:17,color:C.primary,marginBottom:4}}>📋 Principal's Weekly Digest</div>
        <div style={{fontSize:12,color:C.muted,marginBottom:14}}>Weekly reports submitted by the Principal. Review each one and add your comments.</div>
        <div style={{display:"flex",gap:14,flexWrap:"wrap"}}>
          {[["📥","Awaiting Your Review",pending,C.amber,C.amberPale],["✅","Reviewed",reviewed,C.primary,C.primaryPale]].map(([icon,lbl,val,col,bg])=>(
            <div key={lbl} style={{background:bg,borderRadius:10,padding:"8px 16px",display:"flex",alignItems:"center",gap:10,border:`1px solid ${col}33`}}>
              <span style={{fontSize:18}}>{icon}</span>
              <div><div style={{fontWeight:900,fontSize:20,color:col,lineHeight:1}}>{val}</div><div style={{fontSize:10,color:C.muted,fontWeight:600,textTransform:"uppercase"}}>{lbl}</div></div>
            </div>
          ))}
        </div>
      </div>

      {digests.length===0 && (
        <div style={{background:C.white,borderRadius:12,padding:30,textAlign:"center",color:C.muted,fontSize:13,border:`1px solid ${C.border}`}}>
          No digests submitted yet. The Principal will submit weekly reports here each Friday.
        </div>
      )}

      {digests.map(d=>{
        const sm = STATUS_META[d.status]||STATUS_META.submitted;
        const isOpen = selectedId===d.id;
        return (
          <div key={d.id} style={{background:C.white,borderRadius:12,border:`2px solid ${d.status==="submitted"?C.amberMid:C.border}`,overflow:"hidden"}}>
            <div onClick={()=>{ setSelectedId(isOpen?null:d.id); setComment(d.management_comment||""); }}
              style={{padding:"14px 18px",display:"flex",justifyContent:"space-between",alignItems:"center",cursor:"pointer",gap:10,flexWrap:"wrap"}}>
              <div>
                <div style={{fontWeight:800,fontSize:14,color:C.text}}>{d.week_label||weekLabel(d.week_start)}</div>
                <div style={{fontSize:11,color:C.muted}}>By {d.submitted_by||"Principal"} · {fmtTime(d.submitted_at)}</div>
              </div>
              <div style={{display:"flex",gap:8,alignItems:"center"}}>
                <span style={{background:sm.bg,color:sm.col,border:`1px solid ${sm.border}`,borderRadius:6,padding:"2px 9px",fontSize:11,fontWeight:700}}>{sm.label}</span>
                <span style={{color:C.muted,fontSize:12}}>{isOpen?"▲":"▼"}</span>
              </div>
            </div>
            {isOpen && (
              <>
                <DigestReadOnly digest={d}/>
                {!readOnly && (
                  <div style={{padding:"0 18px 18px"}}>
                    <div style={{background:C.primaryPale,borderRadius:10,border:`1px solid ${C.border}`,padding:"14px 16px"}}>
                      <div style={{fontWeight:800,fontSize:13,color:C.primary,marginBottom:8}}>💬 Your Comment / Feedback to Principal</div>
                      <textarea value={comment} onChange={e=>setComment(e.target.value)}
                        placeholder="Write your feedback, acknowledgement, or any action points for the principal…"
                        style={{...ta,minHeight:100,background:"white"}}/>
                      <div style={{display:"flex",justifyContent:"flex-end",marginTop:10}}>
                        <button onClick={submitComment} disabled={saving||!comment.trim()} style={btn(!comment.trim()||saving?"#9ca3af":C.primary)}>
                          {saving?"Saving…":"✅ Submit Comment & Mark Reviewed"}
                        </button>
                      </div>
                    </div>
                  </div>
                )}
              </>
            )}
          </div>
        );
      })}
    </div>
  );
}

// ── Main export ────────────────────────────────────────────────────────────
export function PrincipalDigest({ adminRole="admin" }) {
  const [userName, setUserName] = React.useState("");

  React.useEffect(()=>{
    supabase.auth.getUser().then(async ({data:{user}}) => {
      if (!user) return;
      const { data } = await supabase.from("admin_accounts").select("name").eq("email",user.email).maybeSingle();
      setUserName(data?.name||user.email);
    });
  },[]);

  if (adminRole==="principal") return <PrincipalView userName={userName}/>;
  if (adminRole==="admin")     return <AdminView userName={userName}/>;
  return <AdminView userName={userName} readOnly/>;
}
